import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import StarIcon from '@material-ui/icons/StarBorder';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Icon from '@material-ui/core/Icon';
import List from '@material-ui/core/List';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { PopupButton, InlineWidget } from "react-calendly";

import Header from './Header';
import Footer from './Footer';
import FloSQLForm from './FloSQLForm';

const useStyles = makeStyles((theme) => ({
  '@global': {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
    },
  },
  button: {
    margin: theme.spacing(1),
    justifyContent: 'left',
    justify: 'left',
  },
  image: {
    flex: 1,
    padding: 2,
    width: 100,
    height: 100,
    resizeMode: 'contain'
  },
  paper: {
    width: 102,
    height: 102,
    borderRadius:16,
    margin: 'auto',
    justifyContent: 'center',
  },
  link: {
    margin: theme.spacing(1, 1.5),
    textDecoration: 'none',
    color: 'white',
    underline: 'none',
    hover: {
    "&:hover": {
      color: '#cbd5e1'
      }
    }
  },
  text: {
    margin: theme.spacing(1),
  },
  heroContent: {
    padding: theme.spacing(8, 0, 6),
    //backgroundColor: "#cccccc",
  },
  cardContent: {
    backgroundColor: 'white',
    color: '#0284c7'
  },
}));

const tiers = [
  {
    title: 'START YOUR 14-DAY FREE TRIAL',
    subheader: 'START BUILDING DATA PIPELINES ON TOP OF YOUR DATA WAREHOUSE.',
    price: '$0',
    value: '',
    description: [
    'Completely managed Apache Airflow instance',
    'Automatic dependency mapping',
    'Templates and variables for easy coding',
    'Validations for upstream data errors',
    'Up to 3 users',
    '1000 successful tasks',
    'Snowflake integration',
    'Github SSO',
    'Hosted Redash Dashboarding',
    'Email support',],
    buttonText: 'Start Free Trial',
    buttonVariant: 'outlined',
    buttonStyle: {
      color: 'white',
      backgroundColor:'#0284c7',
      borderColor:'#0284c7'
    },
    style: {
      color: 'white',
      backgroundColor:'#0284c7',
      borderColor:'#0284c7'
    }
  },
];

const data_warehouses = [
  { title: 'Snowflake'},
  { title: 'Amazon Redshift'},
  { title: 'Google BigQuery'},
  { title: 'Microsoft Azure'},
  { title: 'Other'},
  ];

export default function RequestDemo() {
  const classes = useStyles();

  return (
    <React.Fragment>
      <CssBaseline />
      <Header/>
      	<Container maxWidth="lg" component="main" className={classes.heroContent}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{padding:10}}
        >
        </Box>
          <form>

          <Grid container alignItems="flex-end" spacing={2}>
            <Grid xs={12} sm={12} md={12} lg={12} alignItems="flex-end" style={{ padding: 20 }}>
              <InlineWidget
                pageSettings={{
                  backgroundColor: 'ffffff',
                  hideEventTypeDetails: false,
                  hideGdprBanner: true,
                  hideLandingPageDetails: false,
                  primaryColor: '00a2ff',
                  textColor: '4d5055'
                }}
                prefill={{
                  customAnswers: {
                  },
                }}
                styles={{
                  height: '1000px'
                }}
                url="https://calendly.com/base13labs/flosql-demo"
                utm={{
                  utmCampaign: 'Data Orchestration',
                  utmContent: 'Request Demo',
                  utmMedium: 'Website',
                  utmSource: 'Base13 Labs',
                  utmTerm: ''
                }}
              />
            </Grid>
           </Grid>

              {/*<Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                style={{padding:0}}
                >
                <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdXVCg45w2vgiFghAO3t4Km47tdQqg3y622hjgFR6zB5fTF8Q/viewform?embedded=true" width="560" height="2379" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
                </Box>*/}
          </form>
      	</Container>
      <Footer/>
    </React.Fragment>
  );
}